import React, { useReducer } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty, getPromotionMainColor } from '../../../lib/ep.js';

import PrizeShop from './PrizeShop.js';
import PromoColsWrapper from '../PromoColsWrapper.js';
import TokensWallet from './TokensWallet.js';

import ActionLink from '../../builder/ActionLink.js';
import ButtonCollection from '../../builder/ButtonCollection.js';
import { useCSS } from '../../../lib/hooks.js';

const PrizeGallery = (props) => {
	useCSS('comp/prize_gallery.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion?.Promotion ?? false;
	const stage = props?.stage?.Stage ?? false;
	const is_builder = props?.is_builder ?? false;

	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'SUCCESS':
				return { ...state, state:'SUCCESS', result:action.result };

			case 'SHOW_ERRORS':
				return { ...state, show_form_errors:true };

			case 'UPDATE_TOKENS':
				const _user_tokens = { ...state.user_tokens };
				if(_user_tokens[action.prize.token] == undefined) return state;

				const once_per_user = action.prize_type?.once_per_user ?? false;

				_user_tokens[action.prize.token] = parseInt(_user_tokens[action.prize.token]) - (parseInt(action.prize.amount) * parseInt(action.qty));

				if(window.menu_ref != undefined) window.menu_ref.getWrappedInstance().setTokens(_user_tokens);

				return {
					...state,
					user_tokens:_user_tokens,
					prizes:(once_per_user) ? state.prizes.map((prize) => {
						if(prize.id != action.prize_type.id) return prize;
						return { ...prize, status:'3' };
					}) : state.prizes,
				};

			default:
				return state;
		}
	}, {
		state:props?.section ?? 'FORM',
		valid:false,
		user_tokens:props?.loyalty?.totals ?? {},
		show_form_errors:false,
		user:{},
		prizes:props?.prizes ?? [],
		result:false,
	});

	const claim = (prize_id, qty, cb) => {
		dispatch({ type:'SHOW_ERRORS' });
		// if(!state.valid) return;

		const prize_type = props.prizes.find((prize) => (prize.id == prize_id));

		if(props.submitQuiz == undefined) {
			$.post(`/promotions/loyalty_purchase/${promotion.id}`, {
				prize_id,
				qty:qty ?? 1,
				token:prize_type.loyalty_price[0].token,
				amount:prize_type.loyalty_price[0].amount,
			}, (res) => {
				if(res.status != 1) {
					cb(res);
					return;
				}

				dispatch({ type:'UPDATE_TOKENS', prize:prize_type.loyalty_price[0], qty, prize_type });
			}, 'JSON');

			return;
		}

		/*
		// ONLY IN USE IF PRIZE_GALLERY IS IN A STAGE TYPE
		props.submitQuiz(0, {
			loyalty:{
				prize_id,token:prize_type.loyalty_price[0].token,
				amount:prize_type.loyalty_price[0].amount,
			},
		}, (result) => {
			if(stage.final_mode == 'redirect') {
				window.location.href = result.url;
				return;
			}

			dispatch({ type:'SUCCESS', result });
		});
		*/
	};

	const description_placeholder = `<h1>${i18n("Redeem your coins")}</h1><p>${i18n("Use the coins you've earned to get these fabulous prizes.")}</p>`;
	let direct_description = (isNotEmpty(stage, 'direct_description')) ? stage.direct_description : description_placeholder;
	direct_description = (isNotEmpty(promotion, 'loyalty_shop_description')) ? promotion.loyalty_shop_description : direct_description;

	/*
	// ONLY IN USE IF PRIZE_GALLERY IS IN A STAGE TYPE
	if(state.state == 'SUCCESS') {
		const introduction_placeholder = `<h1>${i18n("Thank you!")}</h1><p>${i18n("Now share this.")}</p>`;
		const introduction_message = (isNotEmpty(stage, 'final_message')) ? stage.final_message : introduction_placeholder;

		return (
			<div class="layout_conts">
				<div class="flex_cols">
					{(stage.final_image != "") && (
						<div class="flex_col col_1">
							<div class="main_media_flex">
								<img src={stage.full_final_image} alt="" style={{ maxWidth:'100%' }} />
							</div>
						</div>
					)}

					<div class="flex_col col_2">
						<article class="promo_desc gui_main_text_color_on_bg main_text_flex">
							<LeveledHTMLText
								_class={{ other:'promotion_title' }}
							>{introduction_message}</LeveledHTMLText>
						</article>

						<article class="promo_data template_module info_flexwrap gui_main_actions">
							<div class="template_submodule call_to_action_flex enter_flexwrap">
								<div class="enter flex_button gui_big_button register_flex">
									<ActionButton
										_href={(!is_builder) ? state.result.url : null}
									>Finalize</ActionButton>
								</div>
							</div>

							<div class="template_submodule entries_button_flex">
								<span class="view_galleries">
									<ActionLink
										_href={(!is_builder) ? `/promotions/participate/${stage.promotion_id}` : null}
									>Go back</ActionLink>
								</span>
							</div>
						</article>
					</div>
				</div>
			</div>
		)
	}*/

	const tokens = {};
	if(props?.loyalty?.tokens != undefined) {
		Object.keys(props.loyalty?.tokens ?? {}).map((t) => {
			tokens[t] = props.loyalty.tokens[t].LoyaltyToken;
		});
	} else if(props?.tokens?.length > 0) {
		props.tokens.map((t) => {
			tokens[t.LoyaltyToken.id] = t.LoyaltyToken;
		});
	}

	const main_color = getPromotionMainColor(promotion);

	const is_logged = (isNotEmpty(props, 'login_id')) ? true : false;

	return (
		<div>
			<PromoColsWrapper
				main_image={promotion?.full_image_loyalty_shop ?? null}
				main_video={promotion.loyalty_shop_video}
				main_description={direct_description}
				extra_classes="gui_direct_participation"
			>
				{(is_logged) && (
					<TokensWallet
						tokens={tokens}
						totals={state.user_tokens}
						intl={props.intl}
					/>
				)}

				{(is_logged) && (
					<ButtonCollection _class={{ other:'gui_flex_col' }} style={{ gap:'0.5em' }}>
						{/*<ActionLink
							_href={`/loyalty/my_rewards/${promotion.id}`}
						>View my rewards</ActionLink>*/}

						<ActionLink
							_href={`/my_prizes/${promotion.id}`}
						>View my prizes</ActionLink>
					</ButtonCollection>
				)}

				<PrizeShop
					items={state.prizes}
					stage={stage}
					onClaim={claim}
					tokens={tokens}
					user_tokens={state.user_tokens}
					main_color={main_color}
					promotion={promotion}
					is_logged={is_logged}
					is_builder={is_builder}
					intl={props.intl}
				/>
			</PromoColsWrapper>
		</div>
	)
};

export default injectIntl(PrizeGallery);